<template>
    <div class="h-100 min-h-100 w-100" style="width:100%!important;">
        <!-- <transition> -->
            <!-- <keep&#45;alive> -->
                <router-view></router-view>
            <!-- </keep&#45;alive> -->
        <!-- </transition> -->
    </div>
</template>

<script>
    import api from '@/api'
    export default {
        name: 'App',
        components: {
        },
        mounted () {
            setInterval(function(){
                if (this.$store.state.usuario.id) {
                    api.renovarSesion();
                }
            }.bind(this), (2 * 60 * 1000))
        },
        methods: {
            solicitarDatos (comentario) {
                // this.cargando = false;
                var ctx = this;
                return this.$swal.mixin({
                    input: 'text',
                    confirmButtonText: 'Siguiente',
                    reverseButtons: true,
                    showCancelButton: false,
                    showLoaderOnConfirm: true,
                    progressSteps: ['1', '2']
                }).queue([
                    {
                        title: 'Número de teléfono',
                        text: 'Le enviaremos un código de verificación para asegurarnos de que usted no es un robot.',
                        preConfirm: (respuesta) => {
                            ctx.telefono = respuesta;
                            return api.post(
                                '/organizacion/verificar-numero',
                                { numero: respuesta, sms: 1 },
                                (success) => {},
                                (error) => {
                                    this.$swal.showValidationMessage(error.response.data)
                                },
                            )
                        },
                    },
                    {
                        title: 'Código de verificación',
                        text: 'Hemos enviado un código de verificación a su teléfono',
                        confirmButtonText: 'Enviar',
                        preConfirm: (respuesta) => {
                            return api.post(
                                '/organizacion/verificar-numero',
                                {
                                    numero: ctx.telefono,
                                    codigo: respuesta,
                                    verificar: 1,
                                },
                                (success) => {
                                    this.$store.commit('acceso_temporal', success.data);
                                },
                                (error) => {
                                    this.$swal.showValidationMessage(error)
                                },
                            )
                        },
                    },
                ]);
            },
        },
        data () {
            return {
                telefono: '',
            }
        },
    }
</script>

<style lang="css">
    body {
        background-color: #fff;
    }
</style>
